// Copyright 2021 Storro B.V.
// All rights reserved.
// Dit werk is auteursrechtelijk beschermd.
import { randombytes_buf } from 'libsodium-wrappers';
import { buf2hex } from './Util/buf2hex';

export function getRandomString(size: number): string {
  return buf2hex(randombytes_buf(size, 'uint8array')).slice(0, size);
}
